import {
  apiRoutes,
  type DefaultQueryError,
  getPaymentCustomerTransactionFn,
  type TransactionResponse,
} from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

export const useGetPaymentCustomerTransaction = (
  id: string,
  opts?: Omit<
    UseQueryOptions<TransactionResponse, DefaultQueryError>,
    'queryKey'
  >
) =>
  useQuery<TransactionResponse, DefaultQueryError>({
    queryKey: [apiRoutes.payment.transaction_by_id, id],
    queryFn: () => getPaymentCustomerTransactionFn(id),
    ...opts,
  });
